import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap5';

export default function Options({ children, className }) {
  return (
    <Dropdown className={`options ${className}`}>
      <Dropdown.Toggle variant="link">
        <div className="icon-with-text">
          <i className="small-icon options-icon" />
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu align="end">
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
}

Options.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Options.defaultProps = {
  className: '',
};
